import { render, staticRenderFns } from "./ErrorComponent.vue?vue&type=template&id=a474b7ba&"
import script from "./ErrorComponent.vue?vue&type=script&lang=js&"
export * from "./ErrorComponent.vue?vue&type=script&lang=js&"
import style0 from "./ErrorComponent.vue?vue&type=style&index=0&id=a474b7ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports